import React, { useMemo, useCallback } from 'react';
import DawidMenu from '../menu.jsx';
import { useFlowStore, useUiStore, useFlowRegistry } from '../../store/react';

export default function MenuWrapper() {
    const registry = useFlowRegistry();
    const menuFixed = useUiStore((s) => s.menuFixed);
    const setShowSummary = useUiStore((s) => s.setShowSummary);
    const continuousMode = useUiStore((s) => s.continuousMode);
    const setContinuousMode = useUiStore((s) => s.setContinuousMode);
    const currentFlowId = useFlowStore((s) => s.currentFlowId);
    const changeFlow = useFlowStore((s) => s.changeFlow);
    const flowsMap = useMemo(
        () => Object.fromEntries(registry.listFlows().map((f) => [f.id, f])),
        [registry]
    );
    const goSection = useCallback(
        (section) => setShowSummary(section === 'summary'),
        [setShowSummary],
    );
    return (
        <DawidMenu
            menuFixed={menuFixed}
            currentFlowId={currentFlowId}
            flows={flowsMap}
            changeFlow={changeFlow}
            goSection={goSection}
            continuousMode={continuousMode}
            setContinuousMode={setContinuousMode}
        />
    );
}
